// TODO 定义类型
const intervalMap: Map<number, {
  data: Set<Item>,
  timerId: ReturnType<typeof setInterval>,
}> = new Map();

type Item = {
  interval: number; // 时间间隔
  run: Function; // 执行函数
};

/**
 * 添加到定时器中
 * @param interval 间隔时间
 * @returns
 */
function addTimerId(interval: number) {
  // TODO: setTiemout
  // TODO: 1秒的粒度就够了
  return setInterval(() => {
    intervalMap.get(interval)!.data.forEach((item) => {
      item.run();
    });
  }, interval);
}

/**
 * 添加指针项
 * @param item
 */
export function addItem(item: Item) {
  // 已经存在当前时间间隔
  if (intervalMap.has(item.interval)) {
    const interval = intervalMap.get(item.interval);
    interval!.data.add(item);
    // 不存在当前时间间隔
  } else {
    intervalMap.set(item.interval, {
      data: new Set([item]),
      timerId: addTimerId(item.interval),
    });
  }
  item.run();
}

/**
 * 删除指针项
 * @param item
 */
export function deleteItem(item: Item) {
  const interval = intervalMap.get(item.interval);
  interval!.data.delete(item);
  if (interval!.data.size === 0) {
    clearInterval(interval!.timerId);
    intervalMap.delete(item.interval);
  }
}
